import React from 'react';

import { EditorState } from 'draft-js';

import { omitKeys } from '@adsk/alloy-react-helpers';

import useMentionSuggestions from './hooks/useMentionSuggestions';
import MentionPlugin from './layout/MentionPlugin';
import MentionTextarea, {
  MentionTextareaProps,
} from './layout/MentionTextarea';

export type MentionProps = Omit<
  MentionTextareaProps,
  'isLoading' | 'suggestions' | 'onSearchChange'
>;

const Mention = (props: MentionProps) => {
  const { isLoading, suggestions, onSearchChange } = useMentionSuggestions();

  return (
    <MentionTextarea
      isLoading={isLoading}
      suggestions={suggestions}
      onSearchChange={onSearchChange}
      {...props}
    />
  );
};

Mention.displayName = 'Mention';

Mention.propTypes = {
  ...omitKeys(MentionTextarea.propTypes, [
    'suggestions',
    'onSearchChange',
    'isLoading',
  ]),
};

export default Object.assign(Mention, {
  PLACEMENTS: MentionPlugin.PLACEMENTS,
  EMPTY_STATE: EditorState.createEmpty(),
  TYPES: MentionPlugin.TYPES,
});
